
<script>
import vue2Dropzone from "vue2-dropzone";
import { vendorService } from "../../services";
import { required, requiredIf} from "vuelidate/lib/validators";
import config from "../../config";
import { error_message, success_message } from "../../Helper/helper";
import DropzonePopup from "../../components/widgets/dropzone-popup";
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import { routes } from "../../config/api_routes";

export default {
  components: { vueDropzone: vue2Dropzone, DropzonePopup, vendorService,Layout,PageHeader},
    data() {
        return {
            checked: true,
            file1: null,
            tmpCategoryImage: "",
            url: null,
            config: config,
            restaurant_id: "",
            category: {
                menu_name: "",
                menu_name_thai:"",
                status: "1",
                image_name: "",
                menu_description: "",
            },
            image_name: "",
            menu_media_path: "",
            menu_image_delete_url: routes.resImageDeleteUrl,
        };
    },
    validations: {
        category: {
            menu_name: {
                required,
            },
            menu_name_thai: {
                required
            },
            image_name: {
                required: requiredIf(function (nestedModel) {
                    return !(!!this.image_name || !!this.category.image)
                }),
            },
        },
    },
    mounted(){
        this.fetchSubCategory();
    },
    methods: {
        onImagedeleted(value) {
            this.image_name = "";
        },
        fetchSubCategory() {
            vendorService.getMenuById({ id: this.$route.params.id }).then((response) => {
                const{id,menu_name, menu_name_thai, menu_description, status, category_id} = response.data.result;
                this.category = {id, menu_name, menu_name_thai, menu_description,status, category_id};
                this.image_name = response.data.result.image;
                this.menu_media_path = response.data.result.menu_media_path;
            });
        },
        
        updateCategory() {
            this.$v.category.$touch();
            if (this.$v.category.$invalid) {
                setTimeout(()=>{
                    $(".is-invalid:first").focus();
                },500);
                return;
            }
            else{
                vendorService.editMenu(this.category)
                    .then(response => {
                    if (response.data.code === 200) {
                        this.$router.push({ name: "sub-category-list" , params: { category_id: response.data.result }});
                        success_message(response.data.message);
                    } else {
                        error_message(response.data.message);
                    }
                });
            }
        },
    },
};
</script>

<template>
    <Layout>
        <div class="row">
            <div class="col-12">
                <div
                class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
                >
                <div class="page-title-left avatar-main-icon">
                    <div class="avatar-xs mr-3">
                    <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                        <i class="bx bx-briefcase"></i>
                    </span>
                    </div>
                    <div class="report-tag">
                    <h4 class="mb-0 font-size-18">{{ category.menu_name }}</h4>
                    <p>
                        <router-link :to="{ name: 'sub-category-list',params: { category_id: base64(category.category_id) }}">{{ trans.get('__JSON__.Sub Categories') }}</router-link>
                        > {{ category.menu_name }}
                    </p>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <form @submit.prevent="updateCategory">
                    <!-- Category Info Start -->
                    <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">{{ trans.get('__JSON__.Sub Category Info') }}</h4>
                        <p class="card-title-desc"></p>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group" v-if="$auth.setting">
                                    <label class="required">{{ trans.trans('__JSON__.Sub Category Name Language',{ lang: $auth.langauges[0].name }) }}</label>
                                    <input
                                        id="menu_name"
                                        v-model="$v.category.menu_name.$model"
                                        type="text"
                                        class="form-control"
                                        :placeholder="trans.trans('__JSON__.Sub Category Name Language',{lang: $auth.langauges[0].name})"
                                        name="menu_name"
                                        :class="{ 'is-invalid': $v.category.menu_name.$error }"
                                    />
                                    <div v-if="$v.category.menu_name.$error" class="invalid-feedback">
                                        <span v-if="!$v.category.menu_name.required">{{ trans.get('__JSON__.Please enter sub category name') }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-6" v-if="$auth.langauges[1].name !== 'No Secondary Language'">
                                <div class="form-group">
                                    <label class="required">{{ trans.trans('__JSON__.Sub Category Name Language',{lang: $auth.langauges[1].name }) }}</label>
                                    <input
                                        id="menu_name_thai"
                                        name="menu_name_thai"
                                        type="text"
                                        v-model="$v.category.menu_name_thai.$model"
                                        :placeholder="trans.trans('__JSON__.Sub Category Name Language',{lang: $auth.langauges[1].name })"
                                        class="form-control"
                                        :class="{ 'is-invalid': $v.category.menu_name_thai.$error }"
                                    />
                                    <div v-if="$v.category.menu_name_thai.$error" class="invalid-feedback">
                                        <span v-if="!$v.category.menu_name_thai.required">{{ trans.get('__JSON__.Please enter sub category name') }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <div class="form-group" v-if="$auth.setting">
                                    <label>{{ trans.trans('__JSON__.Sub Category Description Language',{lang: $auth.langauges[0].name }) }}</label>
                                    <input
                                        rows="5"
                                        id="menu_description"
                                        name="menu_description"
                                        type="text"
                                        v-model="category.menu_description"
                                        :placeholder="trans.trans('__JSON__.Sub Category Description Language',{lang: $auth.langauges[0].name })"
                                        class="form-control"
                                    />
                                </div>
                            </div>

                            <div class="col-md-6 vendor-status">
                                <b-form-group id="input-group-2" :label="trans.get('__JSON__.Status')" label-for="Status" >
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="swtich-data">
                                                <label class="switch">
                                                <input
                                                    type="checkbox"
                                                    id="togBtn"
                                                    class="switch-on"
                                                    name="status"
                                                    v-model="category.status"
                                                    true-value="1"
                                                    false-value="0"
                                                />
                                                <div class="slider round">
                                                    <!--ADDED HTML -->
                                                    <span class="on">{{ trans.get('__JSON__.Active') }}</span>
                                                    <span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
                                                    <!--END-->
                                                </div>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                    </div>
                    <!-- Category Info End -->

                    <!-- Category Image Start -->
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title required">{{ trans.get('__JSON__.Sub Category Image') }}</h4>
                            <p class="card-title-desc"></p>

                            <div class="row">
                                <div class="col-sm-3">
                                    <dropzone-popup
                                        v-model="category.image_name"
                                        id="image_name"
                                        acceptedFiles=".jpeg,.jpg,.png"
                                        :editable-images="image_name"
                                        :media-path="menu_media_path+'/original'"
                                        :delete-path="menu_image_delete_url"
                                        @image-deleted="this.onImagedeleted"
                                    />
                                    <div v-if="$v.category.image_name.$error" class="invalid-feedback cuisine-img">
                                        <span
                                            v-if="!$v.category.image_name.required"
                                        >{{ trans.get('__JSON__.Please select sub category image') }}.</span>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                            <div class="col-sm-6">
                                <button class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Update') }}</button>
                                <!-- <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button> -->
                                <router-link
                                   :to="{name:'sub-category-list',params: { category_id: base64(category.category_id) } }"
                                >
                                    <b-button 
                                        type="button" 
                                        variant="secondary" 
                                        class="mt-3">
                                        {{ trans.get('__JSON__.Cancel') }}
                                    </b-button>
                                </router-link>
                            </div>
                            </div>
                        </div>
                    </div>
                    <!-- Category Image End -->
                </form>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>